export default "__VITE_ASSET__86a514c0__"